import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";

export const DefaultRedirect = () => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Navigate
      to={
        user?.role === "SUPERUSER" ? "/superuser/dashboard" : "/admin/dashboard"
      }
      replace
    />
  );
};
